"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "urbino": {
    "f407ca15": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "castelboccione": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "54301771": [{
      "hkey": "a0fb7379",
      "slug": "cavallino-montecalende",
      "name": "Cavallino-Montecalende",
      "primary": true,
      "skipSearch": false
    }],
    "cavallino": [{
      "hkey": "a0fb7379",
      "slug": "cavallino-montecalende",
      "name": "Cavallino-Montecalende",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8fcc1bc4": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "cavaticci": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "378fbc16": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "cerquetobono": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34599179": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "coldelce": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce712063": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "colonna": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7a05256d": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "crocicchia": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "083d74aa": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b9f07d5d": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "forquini": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64c871ac": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "ghiaiolo": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d856656": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "girfalco": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e929cdd": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "maciolla": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f18ceba": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "marcella": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "441a8830": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "monte-polo": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "91b47c5a": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "monteavorio": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d714bb5": [{
      "hkey": "a0fb7379",
      "slug": "cavallino-montecalende",
      "name": "Cavallino-Montecalende",
      "primary": true,
      "skipSearch": false
    }],
    "montecalende": [{
      "hkey": "a0fb7379",
      "slug": "cavallino-montecalende",
      "name": "Cavallino-Montecalende",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "urbino"
    }],
    "444e8f36": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "monteolivo": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "961c12ab": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "paganico": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a57c0a23": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo-del-piano": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82d85de5": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "pantiere": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1424157b": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "pozzuolo": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ab79ba1a": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "rancitella": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5957272e": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "repuglia": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "865c38f1": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "s-s-annunziata": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7055ccd": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-delle-selve": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf83192e": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "tortorina": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f8d68779": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "viapiana": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c28e100": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "skipSearch": false
    }],
    "villa-croce": [{
      "hkey": "df7511ab",
      "slug": "urbino",
      "name": "Urbino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;